/**
 * Shared formatting for the library screens.
 *
 * Its own module rather than an export from a page component: the page
 * imports the leaderboard and the leaderboard needs the formatter, which
 * would be a cycle.
 */

/**
 * Study time, the way a person says it.
 *
 * Under a minute reads as "<1m" rather than "0m" — a zero beside somebody's
 * name looks like a fault rather than a new arrival.
 */
export function hoursMinutes(seconds: number): string {
  if (seconds < 60) return '<1m'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m`
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  return rest === 0 ? `${hours}h` : `${hours}h ${rest}m`
}

/** Initials for an avatar slot, from a first name. */
export function initials(name: string): string {
  const trimmed = name.trim()
  return trimmed ? trimmed.slice(0, 2).toUpperCase() : '?'
}

/**
 * A break countdown as mm:ss.
 *
 * Minutes and seconds, not "29m": a number that visibly moves every second
 * is what tells a student the break is really running, and the last minute
 * is the one they care about.
 */
export function countdown(seconds: number): string {
  const safe = Math.max(0, Math.floor(seconds))
  const mins = Math.floor(safe / 60)
  const secs = safe % 60
  return `${mins}:${String(secs).padStart(2, '0')}`
}
